module.exports = new __parcel__URL__("CineBrick.ad520543.jpeg").toString();